var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"m_btns"},_vm._l((_vm.rightItems),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.routerLink(item)}}},[_c('i',{class:item.iconClass}),_c('span',[_vm._v(_vm._s(item.name))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }